import React from 'react';
import {withStyles} from 'material-ui/styles';

import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import Collapsible from 'react-collapsible';
import List, {ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction} from 'material-ui/List';
import Rowing from 'material-ui-icons/Rowing';
import Circle from 'material-ui-icons/FiberManualRecord';
import ChartAnalytics from './ChartAnalytics';
import axios from "axios";
import * as host from "../../../host/host";
import {CircularProgress} from 'material-ui/Progress';

import {DatePicker} from 'material-ui-pickers';
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import ruLocale from 'date-fns/locale/ru';

import {MuiThemeProvider, createMuiTheme} from 'material-ui';

const materialTheme = createMuiTheme({
    overrides: {
        typography: {
            // Tell Material-UI what's the font-size on the html element is.
            fontSize: '1.5rem'
        },
        DateTimePicker: {
            fontSize: '1.5rem'
        },
        MuiPickersToolbar: {
            toolbar: {
                fontSize: '1.5rem',
                width: '100%',
                display: '-webkit-inline-box',
                padding: '25px 50px',
                height: 70,
                minHeight: 70
            }
        },
        MuiPickersCalendarHeader: {
            daysHeader: {
                fontSize: '1.5rem'
            },
            switchHeader: {
                fontSize: '1.5rem'
            },
            dayLabel: {
                fontSize: '1.5rem'
            }
        },
        MuiPickersDay: {
            day: {
                fontSize: '1.5rem'
            },
            selected: {
                fontSize: '1.5rem'
            },
            current: {
                fontSize: '1.5rem'
            }
        },
        MuiTypography: {
            root: {
                fontSize: '1.5rem'
            },
            body1: {
                fontSize: '2rem',
                lineHeight: '1.63em'
            }
        },
        MuiPickersToolbarButton: {
            toolbarBtn: {
                margin: '0px 15px'
            }
        },
        MuiDialogActions: {
            button: {
                fontSize: 15,
                color: 'white',
            },
            action: {
                '&:first-child': {
                    // float: 'left',
                    display: 'none'
                },
                '&:last-child': {
                    // float: 'right',
                    width: '100%',
                    textAlign: 'center',
                    backgroundColor: '#3f51b5',
                },
            },
        },
    }
});

const styles = theme => ({
    svgDeterminate: {
        animation: 'mui-progress-circular-rotate 1.4s linear infinite',
        transform: 'rotate(0deg)',
        width: '150px',
    },
    root: {
        justifyContent: 'center',
        flexWrap: 'wrap',
        padding: theme.spacing.unit / 2,
    },
    chip: {
        margin: theme.spacing.unit / 2,
    },
    rootListItem: {
        fontSize: 20
    },
    activeCount: {
        padding: 13,
        fontWeight: 600,
        fontSize: 20
    },
    primaryListItem: {
        fontSize: 16
    },
    collapse: {
        boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
        borderBottomRightRadius: 20,
        borderBottomLeftRadius: 20
    },
    fontSizeDefault: {
        fontSize: '16px',
        border: '1px solid #beb7b7',
        borderRadius: '3px',
        color: '#273140 ',
        marginTop: 5,
        paddingLeft: 7,
        [theme.breakpoints.up('md')]: {},
        backgroundColor: '#FFF',
        height: '34px'
    },
});

class Analytics extends React.Component {
    constructor(props) {
        super(props);
        this.handleDateCompaniesChange = this.handleDateCompaniesChange.bind(this);
        this.handleDateUsersChange = this.handleDateUsersChange.bind(this);
        this.state = {
            companies: [],
            users: [],
            companies_analytics: [],
            users_analytics: [],
            tariffs: [],

            newDateCompanies: '',
            selectedDateCompanies: new Date(),

            newDateUsers: '',
            selectedDateUsers: new Date(),
        };
    }

    handleDateCompaniesChange = (date) => {
        const _this = this;
        let month = date.getMonth() + 1;
        let day = date.getDate();
        if (month.toString().length === 1) {
            month = '0' + month;
        }
        if (day.toString().length === 1) {
            day = '0' + day;
        }
        this.setState({
            selectedDateCompanies: date,
            newDateCompanies: date.getFullYear() + '-' + month + '-' + day
        }, function () {
            axios({
                url: host.url + '/admin/get_analytics_companies_date',
                method: 'post',
                data: {
                    date: date.getFullYear() + '-' + month + '-' + day
                }
            }).then(function (response) {
                console.log('response', response);
                let sortCompanies = response.data.data.companies.tile.slice();
                sortCompanies.sort((a, b) => (a.tariff.label < b.tariff.label ? -1 : 1));
                _this.setState({
                    companies: sortCompanies
                }, function () {
                    _this.setState({
                        circularProgress: false
                    });
                });
            }).catch(function (error) {
                console.log('analytics', error);
            });
        });
    };

    handleDateUsersChange = (date)  => {
        const _this = this;
        let month = date.getMonth() + 1;
        let day = date.getDate();
        if (month.toString().length === 1) {
            month = '0' + month;
        }
        if (day.toString().length === 1) {
            day = '0' + day;
        }
        this.setState({
            selectedDateUsers: date,
            newDateUsers: date.getFullYear() + '-' + month + '-' + day
        }, function () {
            axios({
                url: host.url + '/admin/get_analytics_users_date',
                method: 'post',
                data: {
                    date: date.getFullYear() + '-' + month + '-' + day
                }
            }).then(function (response) {
                console.log('response', response);
                _this.setState({
                    users: response.data.data.users.tile
                }, function () {
                    _this.setState({
                        circularProgress: false
                    });
                });
            }).catch(function (error) {
                console.log('analytics', error);
            });
        });
    };

    componentDidMount() {
        const _this = this;
        console.log('componentDidMount Analytics');
        console.log('props', _this.props);
        _this.setState({
            circularProgress: true
        });
        axios({
            url: host.url + '/admin/get_analytics',
            method: 'post',
        }).then(function (response) {
            let sortCompanies = response.data.data.companies.tile.slice();
            sortCompanies.sort((a, b) => (a.tariff.label < b.tariff.label ? -1 : 1));
            _this.setState({
                users: response.data.data.users.tile,
                companies: sortCompanies,
                users_analytics: response.data.data.users.analytics,
                companies_analytics: response.data.data.companies.analytics,
                tariffs: response.data.data.tariffs
            }, function () {
                _this.setState({
                    circularProgress: false
                });
            });
            console.log('response', response);

        }).catch(function (error) {
            console.log('analytics', error);
        });
    }

    render() {
        const _this = this;
        const {classes} = this.props;
        const {selectedDateCompanies, selectedDateUsers} = _this.state;
        return (
            <div style={{
                overflowX: 'hidden', marginTop: 10, overflowY: 'hidden',
                // height: 'calc(100vh + 26px)'
            }}>
                {_this.state.circularProgress ?
                    <Grid container spacing={0} style={{textAlign: 'center', display: 'inherit', marginTop: 50}}>
                        <CircularProgress
                            className={classes.progress}
                            classes={{svgDeterminate: classes.svgDeterminate, root: classes.rootCircularProgress}}
                            mode="determinate"
                            value={75}/>
                    </Grid> :
                    <div>
                        <Grid container spacing={8}>
                            <Grid item xs={12} md={4}>
                                <Collapsible
                                    className={classes.collapse}
                                    openedClassName={classes.collapse}
                                    trigger={
                                        <Paper>
                                            <List>
                                                <ListItem button>
                                                    <ListItemIcon>
                                                        <Rowing/>
                                                    </ListItemIcon>
                                                    <ListItemText classes={{primary: classes.rootListItem}}
                                                                  inset
                                                                  primary='КОМПАНИИ'/>
                                                    <ListItemSecondaryAction>
                                                        <div style={{display: 'inline-flex'}}>
                                                            <MuiPickersUtilsProvider utils={DateFnsUtils}
                                                                                     locale={ruLocale}>
                                                                <MuiThemeProvider theme={materialTheme}>
                                                                    <div className='picker'>
                                                                        <DatePicker
                                                                            autoOk
                                                                            ampm={false}
                                                                            value={selectedDateCompanies}
                                                                            onChange={_this.handleDateCompaniesChange}
                                                                            label="Дата"
                                                                            autoSubmit={false}
                                                                            cancelLabel={'Отмена'}
                                                                            okLabel={'Выбор'}
                                                                            TextFieldComponent={'input'}
                                                                            className={classes.fontSizeDefault}
                                                                            format="DD.MM.YYYY"
                                                                            // style={{width: '100%'}}
                                                                        />
                                                                    </div>
                                                                </MuiThemeProvider>
                                                            </MuiPickersUtilsProvider>
                                                            <Typography type="title"
                                                                        style={{
                                                                            fontSize: '25px',
                                                                            padding: '9px',
                                                                            letterSpacing: '2px',
                                                                            fontWeight: 600,
                                                                        }}>
                                                                {_this.state.companies.length}
                                                            </Typography>
                                                        </div>
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            </List>
                                        </Paper>
                                    }>
                                    <div style={{maxHeight: 330, overflowY: 'scroll'}}>
                                        {_this.state.companies.map(company => (
                                            <Paper key={company._id}>
                                                <List disablePadding>
                                                    <ListItem>
                                                        <ListItemText classes={{primary: classes.primaryListItem}}
                                                                      primary={<div>
                                                                          <div
                                                                              style={{fontWeight: 500}}>{company.name}</div>
                                                                          {company.owner_email}</div>}
                                                        />
                                                        <ListItemSecondaryAction>
                                                            <Circle style={
                                                                company.tariff.label === "I" ? {color: '#ffe599'} : company.tariff.label === "II" ? {color: '#ffd966'} : company.tariff.label === "III" ? {color: '#f1c232'} : company.tariff.label === "B" ? {color: '#b4a7d6'} : company.tariff.label === "T" ? {color: '#c9daf8'} : {color: 'black'}
                                                            }/>
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                </List>
                                            </Paper>
                                        ))}
                                    </div>
                                </Collapsible>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Paper>
                                    <ChartAnalytics title={'Активность компаний'}
                                                    data={_this.state.companies_analytics}/>
                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid container spacing={8} style={{marginTop: 50}}>
                            <Grid item xs={12} md={4}>
                                <Collapsible
                                    className={classes.collapse}
                                    openedClassName={classes.collapse}
                                    trigger={
                                        <Paper>
                                            <List>
                                                <ListItem button>
                                                    <ListItemIcon>
                                                        <Rowing/>
                                                    </ListItemIcon>
                                                    <ListItemText classes={{primary: classes.rootListItem}}
                                                                  inset
                                                                  primary='ПОЛЬЗОВАТЕЛИ'/>
                                                    <ListItemSecondaryAction>
                                                        <div style={{display: 'inline-flex'}}>
                                                            <MuiPickersUtilsProvider utils={DateFnsUtils}
                                                                                     locale={ruLocale}>
                                                                <MuiThemeProvider theme={materialTheme}>
                                                                    <div className='picker'>
                                                                        <DatePicker
                                                                            autoOk
                                                                            ampm={false}
                                                                            value={selectedDateUsers}
                                                                            onChange={_this.handleDateUsersChange}
                                                                            label="Дата"
                                                                            autoSubmit={false}
                                                                            cancelLabel={'Отмена'}
                                                                            okLabel={'Выбор'}
                                                                            TextFieldComponent={'input'}
                                                                            className={classes.fontSizeDefault}
                                                                            format="DD.MM.YYYY"
                                                                            // style={{width: '100%'}}
                                                                        />
                                                                    </div>
                                                                </MuiThemeProvider>
                                                            </MuiPickersUtilsProvider>
                                                            <Typography type="title"
                                                                        style={{
                                                                            fontSize: '25px',
                                                                            padding: '9px',
                                                                            letterSpacing: '2px',
                                                                            fontWeight: 600,
                                                                        }}>
                                                                {_this.state.users.length}
                                                            </Typography>
                                                        </div>
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            </List>
                                        </Paper>
                                    }>
                                    <div style={{maxHeight: 330, overflowY: 'scroll'}}>
                                        {_this.state.users.map(user => (
                                            <Paper key={user._id}>
                                                <List disablePadding>
                                                    <ListItem>
                                                        <ListItemText classes={{primary: classes.primaryListItem}}
                                                                      primary={<div>
                                                                          <div
                                                                              style={{fontWeight: 500}}>{user.name}</div>
                                                                          {user.email}</div>}
                                                        />
                                                    </ListItem>
                                                </List>
                                            </Paper>
                                        ))}
                                    </div>
                                </Collapsible>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Paper>
                                    <ChartAnalytics
                                        data={_this.state.users_analytics}
                                        title={'Активность пользователей'}/>
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>
                }
            </div>
        );
    }
}

export default withStyles(styles, {withTheme: true})(Analytics);



// WEBPACK FOOTER //
// ./src/components/tabs/analytics/Analytics.js